import { ShopOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';
import { WithClassname } from '../../../../types';
import useStore from '../../../../hooks/context/useStore';
import { StoreDetails } from '../../../../types/store';
import useNotification from '../../../../hooks/context/useNotification';

type Props = {
  id: string;
  data: Pick<StoreDetails, 'name'>;
} & WithClassname;

export default function StorePreview({ id, data, className }: Props) {
  const { onPreviewStore } = useStore();

  const { notificationApi } = useNotification();

  const [loading, setLoading] = useState(false);

  const _onPreviewStore = () => {
    setLoading(true);
    onPreviewStore(id)
      .catch(() => notificationApi.error({ message: 'Failed to load store details' }))
      .finally(() => setLoading(false));
  };

  return (
    <h6 className={className}>
      <ShopOutlined className="mr-xs text-md" />
      {data.name}
      <Button type="link" loading={loading} onClick={_onPreviewStore}>
        Show details
      </Button>
    </h6>
  );
}
